import * as THREE from 'three'

export default function createScene()
{
  return new THREE.Scene()
}
